let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("kRL9H")).then(() => parcelRequire('8njZH'));